import { render, staticRenderFns } from "./InviteFriends.vue?vue&type=template&id=79305bbd&scoped=true"
import script from "./InviteFriends.vue?vue&type=script&lang=js"
export * from "./InviteFriends.vue?vue&type=script&lang=js"
import style0 from "./InviteFriends.vue?vue&type=style&index=0&id=79305bbd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79305bbd",
  null
  
)

export default component.exports